import { CheckBox, Spinner, theme } from '@zappyrent/hundop';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import paymentsAPI from '../../../../services/api/payments';
import useStore from '../../../../store';
import {
  StyledError,
  StyledParagraph,
  StyledSection,
  StyledSubtitle,
} from '../UserPayments.styles';
import { UserPaymentsTOSProps } from './UserPaymentsTOS.types';

const UserPaymentsTOS = ({
  areTOSAccepted,
  setAccountInfo,
}: UserPaymentsTOSProps): JSX.Element => {
  const { t } = useTranslation([
    'a11y',
    'common',
    'form',
    'navigation',
    'payments',
  ]);
  const user = useStore(state => state.user);
  const userType = user?.type;

  const [isLoading, setIsLoading] = useState(false);
  const [TOSAcceptanceError, setTOSAcceptanceError] = useState<string>();

  const handleTermsAndConditionsChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const acceptance = event.target.checked;
    if (!acceptance) return;
    else setTOSAcceptanceError(undefined);

    try {
      setIsLoading(true);
      await paymentsAPI.acceptTermsOfService();
      setAccountInfo(prevAccountInfo => ({
        areTOSAccepted: true,
        ...prevAccountInfo,
      }));
    } catch (err) {
      console.error(err);
      setTOSAcceptanceError(t('payments:TOSAcceptanceError'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <StyledSection>
      <StyledSubtitle>
        {t('common:termsAndConditions')}
        {isLoading && (
          <Spinner
            foregroundColor={theme.colors.mainAlternate}
            size={14}
            strokeSize={2}
          />
        )}
      </StyledSubtitle>
      <StyledParagraph>
        <Trans
          components={{
            a: <a />,
          }}
          i18nKey="payments:termsAndConditionsDisclaimer"
          t={t}
          values={{
            link: t('navigation:termsAndConditionsLink'),
          }}
        />
      </StyledParagraph>
      <CheckBox
        id="terms_and_conditions"
        name="terms_and_conditions"
        label={t('common:iAcceptTermsAndConditions')}
        checked={areTOSAccepted}
        onChange={handleTermsAndConditionsChange}
        user={userType}
      />
      {TOSAcceptanceError && <StyledError>{TOSAcceptanceError}</StyledError>}
    </StyledSection>
  );
};

export default UserPaymentsTOS;
